// ============================================================================
// MAIN PRODUCT PAGE FUNCTIONALITY
// ============================================================================
// This file contains all JavaScript functionality for the product page,
// including pet banner name handling, "No thanks" link placement, and
// deduplication of payment buttons.

(function() {
    'use strict';
  
    // ============================================================================
    // UTILITY FUNCTIONS
    // ============================================================================
  
    function getCookieLocal(name) {
      var cname = name + "=";
      var decoded = decodeURIComponent(document.cookie || "");
      var parts = decoded.split(';');
      for (var i = 0; i < parts.length; i++) {
        var c = parts[i].trim();
        if (c.indexOf(cname) === 0) return c.substring(cname.length, c.length);
      }
      return "";
    }
  
    // ============================================================================
    // PET BANNER NAME HANDLING
    // ============================================================================
  
    function initPetBannerName() {
      var productInfo = document.querySelector('[data-section]');
      if (!productInfo) return;
  
      var productTitle = productInfo.getAttribute('data-product-title') || '';
      var sectionId = productInfo.getAttribute('data-section') || '';
      var banner = document.getElementById('pet-top-banner');
      
      if (!banner) return; // Exit if no banner found
  
      function getProductTypeFlags() {
        var titleLower = (productTitle || "").toLowerCase();
        return {
          isCat: titleLower.indexOf('cat') !== -1,
          isDog: titleLower.indexOf('dog') !== -1
        };
      }
  
      function getNameFromPetsInfo() {
        try {
          var raw = getCookieLocal('pets_info');
          if (!raw || raw === '[]') return null;
          var pets = JSON.parse(raw);
          if (!Array.isArray(pets) || pets.length === 0) return null;
          var flags = getProductTypeFlags();
          var matching = pets.filter(function (p) {
            if (flags.isCat && p.type === 'cat') return true;
            if (flags.isDog && p.type === 'dog') return true;
            return false;
          });
          var chosen = matching.length ? matching[matching.length - 1] : pets[pets.length - 1];
          var name = chosen && chosen.name ? chosen.name.trim() : null;
          if (name) {
            console.log('[Pet Banner] Found name from pets_info:', name);
          }
          return name;
        } catch (e) {
          console.error('[Pet Banner] Error parsing pets_info:', e);
          return null;
        }
      }
  
      function getNameFromLegacy() {
        try {
          var raw = getCookieLocal('pet_info');
          if (!raw) return null;
          var obj = JSON.parse(raw);
          return obj && obj.name ? obj.name : null;
        } catch (e) {
          return null;
        }
      }
  
      function setBannerName(name) {
        var span = document.querySelector('#pet-top-banner .pet-banner__name');
        if (span && name && name.trim()) {
          span.textContent = name.trim();
          banner.style.display = 'block'; // Make sure banner is visible
          console.log('[Pet Banner] Updated name via initPetBannerName:', name.trim());
        } else {
          banner.style.display = 'none'; // Hide banner if no name
        }
      }
  
      function getNameFromCartProperties() {
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(r){ return r.json(); })
          .then(function(cart){
            if (!cart || !cart.items || !cart.items.length) return null;
            var flags = getProductTypeFlags();
            var items = cart.items.slice();
            var extractName = function(str){
              if (!str) return null;
              var m = /Name:\s*([^,]+)/i.exec(str);
              return m ? m[1].trim() : null;
            };
            var pick = function(arr){
              for (var i=arr.length-1; i>=0; i--) {
                var props = arr[i].properties || {};
                var details = props['Pet Details'];
                var n = extractName(details);
                if (n) return n;
              }
              return null;
            };
            var preferred = items.filter(function(it){
              var t = (it.title || '').toLowerCase();
              if (flags.isCat) return t.indexOf('cat') !== -1;
              if (flags.isDog) return t.indexOf('dog') !== -1;
              return false;
            });
            return pick(preferred) || pick(items);
          })
          .catch(function(){ return null; });
      }
  
      // Try to get name from all sources and update banner
      // First check localStorage (fastest, most reliable)
      var nameFromStorage = null;
      try {
        nameFromStorage = localStorage.getItem('pawplan_pet_name');
        if (nameFromStorage) nameFromStorage = nameFromStorage.trim();
      } catch(e) {}
      
      var name = nameFromStorage || getNameFromPetsInfo() || getNameFromLegacy();
      if (name && name.trim()) {
        setBannerName(name.trim());
        console.log('[Pet Banner] Initial name set from storage/cookies:', name.trim());
      } else {
        // If not found in cookies/storage, try cart properties
        getNameFromCartProperties().then(function(cartName) {
          if (cartName && cartName.trim()) {
            setBannerName(cartName.trim());
            console.log('[Pet Banner] Name set from cart properties:', cartName.trim());
          }
        });
      }
  
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          var petName = getNameFromPetsInfo() || getNameFromLegacy();
          if (petName) {
            setBannerName(petName);
          } else {
            getNameFromCartProperties().then(function(cartName) {
              if (cartName) setBannerName(cartName);
            });
          }
        });
      } else {
        var petName = getNameFromPetsInfo() || getNameFromLegacy();
        if (petName) {
          setBannerName(petName);
        } else {
          getNameFromCartProperties().then(function(name){
            if (name) setBannerName(name);
          });
        }
      }
  
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateBanner);
      } else {
        updateBanner();
      }
    }
  
    // ============================================================================
    // "NO THANKS" LINK PLACEMENT
    // ============================================================================
  
    function initNoThanksLink() {
      var productInfo = document.querySelector('[data-section]');
      if (!productInfo) return;
  
      var sectionId = productInfo.getAttribute('data-section') || '';
      var productFormId = productInfo.getAttribute('data-product-form-id') || '';
      var rootUrl = productInfo.getAttribute('data-root-url') || '/';
  
      function getProductForm() {
        if (productFormId) {
          var byId = document.getElementById(productFormId);
          if (byId) return byId;
        }
        var el =
          document.querySelector('#ProductInfo-' + sectionId + ' form[id^="product-form-"]') ||
          document.querySelector('product-form form[id^="product-form-"]') ||
          document.querySelector('form[action*="/cart/add"]');
        return el || null;
      }
  
      function placeNoThanks() {
        var form = getProductForm();
        if (!form) return;
  
        var addBtn = form.querySelector('button[name="add"], button[type="submit"]');
        var paymentWrap = form.closest('#ProductInfo-' + sectionId)
                          ?.querySelector('.shopify-payment-button');
        var noThanks = document.querySelector('.no-thanks-link');
  
        if (!noThanks || !addBtn) return;
  
        if (addBtn.nextElementSibling !== noThanks) {
          addBtn.insertAdjacentElement('afterend', noThanks);
        }
  
        if (paymentWrap) {
          if (paymentWrap.previousElementSibling !== noThanks) {
            paymentWrap.parentElement.insertBefore(noThanks, paymentWrap);
          }
        }
      }
  
      document.addEventListener('click', function (e) {
        var a = e.target.closest('.js-no-thanks');
        if (!a) return;
        e.preventDefault();
        if (document.referrer && window.history.length > 1) {
          window.history.back();
        } else {
          window.location.href = rootUrl;
        }
      });
  
      document.addEventListener('DOMContentLoaded', placeNoThanks);
      var obs = new MutationObserver(placeNoThanks);
      obs.observe(document.body, { childList: true, subtree: true });
    }
  
    // ============================================================================
    // DEDUPLICATION OF PAYMENT BUTTONS AND "NO THANKS" LINKS
    // ============================================================================
  
    function initDeduplication() {
      var productInfo = document.querySelector('[data-section]');
      if (!productInfo) return;
  
      var sectionId = productInfo.getAttribute('data-section') || '';
      var ROOT_SEL = '#ProductInfo-' + sectionId;
  
      function dedupeInside(root) {
        if (!root) return;
  
        var payBtns = root.querySelectorAll('.shopify-payment-button');
        if (payBtns.length > 1) {
          payBtns.forEach(function (el, i) {
            if (i > 0) el.remove();
          });
        }
  
        var noThanks = root.querySelectorAll('.no-thanks-link');
        if (noThanks.length > 1) {
          noThanks.forEach(function (el, i) {
            if (i > 0) el.remove();
          });
        }
      }
  
      function runDedupe() {
        var root = document.querySelector(ROOT_SEL);
        dedupeInside(root);
      }
  
      document.addEventListener('DOMContentLoaded', runDedupe);
      new MutationObserver(runDedupe).observe(document.querySelector('body'), {
        childList: true,
        subtree: true
      });
    }
  
    // ============================================================================
    // PET BANNER NAME UPDATE
    // ============================================================================
  
    function initPetBannerNameUpdate() {
      var banner = document.getElementById('pet-top-banner');
      if (!banner) return;

      var nameSpan = banner.querySelector('.pet-banner__name');

      function setBannerName(name) {
        var finalName = (name && String(name).trim()) ? name.trim() : 'your pet';
        if (nameSpan) {
          nameSpan.textContent = finalName;
          // Make sure banner is visible when name is set
          banner.style.display = 'block';
        }
        console.log('[Pet Banner] Updated name to:', finalName);
      }

      function getPetName() {
        try {
          if (window.PawPlan && window.PawPlan.pet && window.PawPlan.pet.name) {
            return window.PawPlan.pet.name;
          }
        } catch(e){}

        // Check localStorage first (most reliable for immediate updates)
        var keys = ['pawplan_pet_name','pawplan.pet_name','pet_name'];
        for (var i=0; i<keys.length; i++) {
          var v = localStorage.getItem(keys[i]) || sessionStorage.getItem(keys[i]);
          if (v && v.trim()) return v.trim();
        }

        // Check cookies (pets_info array)
        try {
          var petsInfoCookie = getCookieLocal('pets_info');
          if (petsInfoCookie) {
            var pets = JSON.parse(petsInfoCookie);
            if (pets && Array.isArray(pets) && pets.length > 0) {
              var latestPet = pets[pets.length - 1];
              if (latestPet && latestPet.name && latestPet.name.trim()) {
                return latestPet.name.trim();
              }
            }
          }
        } catch(e) {}

        // Check legacy pet_info cookie
        try {
          var petInfoCookie = getCookieLocal('pet_info');
          if (petInfoCookie) {
            var petInfo = JSON.parse(petInfoCookie);
            if (petInfo && petInfo.name && petInfo.name.trim()) {
              return petInfo.name.trim();
            }
          }
        } catch(e) {}

        // Check pet_name cookie
        var m = document.cookie.match(/(?:^|;)\s*pet_name=([^;]+)/);
        if (m) return decodeURIComponent(m[1]);

        // Check URL params
        var qs = new URLSearchParams(location.search);
        if (qs.has('pet_name')) return qs.get('pet_name');

        return '';
      }

      // Initial load
      var initialName = getPetName();
      if (initialName) {
        setBannerName(initialName);
      } else {
        // Hide banner if no name found
        banner.style.display = 'none';
      }

      // Listen for pet-updated events (dispatched from popup form)
      document.addEventListener('pawplan:pet-updated', function (ev) {
        var n = ev && ev.detail && ev.detail.name;
        console.log('[Pet Banner] Received pawplan:pet-updated event:', ev.detail);
        if (n && n.trim()) {
          try { 
            localStorage.setItem('pawplan_pet_name', n.trim()); 
            console.log('[Pet Banner] Saved to localStorage:', n.trim());
          } catch(e){
            console.error('[Pet Banner] Error saving to localStorage:', e);
          }
          setBannerName(n.trim());
        }
      });

      // Also listen for storage events (in case updated from another tab/window)
      window.addEventListener('storage', function(e) {
        if (e.key === 'pawplan_pet_name' && e.newValue) {
          setBannerName(e.newValue);
        }
      });

      // Poll for updates (fallback for slower cookie updates)
      var tries = 0;
      var poll = setInterval(function(){
        var nm = getPetName();
        if (nm) { 
          setBannerName(nm); 
          clearInterval(poll); 
        }
        if (++tries > 20) clearInterval(poll);
      }, 100);
    }
  
    // ============================================================================
    // PET NAME INPUT LISTENER
    // ============================================================================
  
    function initPetNameInputListener() {
      var nameInput = document.querySelector('#pet-name');
  
      function updateNameFromInput() {
        if (!nameInput) return;
        var n = (nameInput.value || '').trim();
        if (!n) return;
  
        try { localStorage.setItem('pawplan_pet_name', n); } catch(e) {}
  
        document.dispatchEvent(new CustomEvent('pawplan:pet-updated', {
          detail: { name: n }
        }));
      }
  
      if (nameInput) {
        nameInput.addEventListener('input', updateNameFromInput);
        nameInput.addEventListener('change', updateNameFromInput);
      }
  
      document.addEventListener('DOMContentLoaded', function () {
        if (nameInput && nameInput.value && nameInput.value.trim()) {
          updateNameFromInput();
        }
      });
    }
  
    // ============================================================================
    // INITIALIZATION
    // ============================================================================
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initPetBannerName();
        initNoThanksLink();
        initDeduplication();
        initPetBannerNameUpdate();
        initPetNameInputListener();
      });
    } else {
      initPetBannerName();
      initNoThanksLink();
      initDeduplication();
      initPetBannerNameUpdate();
      initPetNameInputListener();
    }
  
  })();
  